import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from "@angular/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { MatCardModule } from "@angular/material/card";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatRadioButton, MatRadioGroup } from "@angular/material/radio";
import { MatDialog } from "@angular/material/dialog";
import { AppUrlConstants } from "../../../core/constants/AppUrlConstants";
import { GenericCrudService } from "../../../core/services/generic-crud.service";
import { AlertDialogComponent } from "../../../shared/alert-dialog/alert-dialog.component";
import { Router } from "@angular/router";
import { ApplicationDataService } from "../../../core/services/application-data.service";
import { AuthenticationService } from "../../../core/services/authentication.service";
import { TokenStorageService } from "../../../core/services/token-storage.service";
import { COMPLAINT_SOURCE, WORK_CODE } from "../../../core/constants/app.const";
import { DatePipe, JsonPipe } from "@angular/common";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import {
  CountryISO,
  NgxIntlTelInputModule,
  PhoneNumberFormat,
  SearchCountryField,
} from "ngx-intl-tel-input-gg";
import { NgxEditorModule } from "ngx-editor";
import { Editor, Toolbar } from "ngx-editor";
import { Plugin, PluginKey } from 'prosemirror-state';

@Component({
  selector: "app-complaint-add",
  standalone: true,
  providers: [DatePipe],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatOptionModule,
    JsonPipe,
    MatSelectModule,
    MatCardModule,
    MatGridListModule,
    MatRadioGroup,
    MatRadioButton,
    DatePipe,
    MatCheckboxModule,
    NgxIntlTelInputModule,
    NgxEditorModule,
  ],
  templateUrl: "./complaint-add.component.html",
  styleUrl: "./complaint-add.component.css",
})
export class ComplaintAddComponent implements OnDestroy {
  @Input() data: any;
  @Output() event: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild("searchComplaint") searchComplaint: ElementRef<HTMLInputElement>;
  @ViewChild("searchSubCat") searchSubCat: ElementRef<HTMLInputElement>;
  @ViewChild("searchDivision") searchDivision: ElementRef<HTMLInputElement>;
  @ViewChild("searchDistrict") searchDistrict: ElementRef<HTMLInputElement>;
  @ViewChild("searchTehsil") searchTehsil: ElementRef<HTMLInputElement>;
  @ViewChild("searchMouza") searchMouza: ElementRef<HTMLInputElement>;

  form: FormGroup;
  categoryList: any[] = [];
  originalCategoryList: any[] = [];
  subCategoryList: any[] = [];
  originalSubbCategoryList: any[] = [];
  sCategoryList: any[] = [];
  divisionList: any[] = [];
  districtList: any[] = [];
  tehsilList: any[] = [];
  mouzaList: any[] = [];
  usersList: any[] = [];
  complainantTitle: string[] = ["Mr.", "Ms."];
  workCodeList: string[] = WORK_CODE;
  sourceList: string[] = COMPLAINT_SOURCE;

  divisionIds: any[] = [];
  districtIds: any[] = [];
  tehsilIds: any[] = [];
  mouzaIds: any[] = [];
  workFlowStepsds: any[] = [];

  allDivisionList: any[] = [];
  originalDivisionList: any[] = [];
  allDistrictList: any[] = [];
  originalDistrictList: any[] = [];
  allTehsilList: any[] = [];
  originalTehsilList: any[] = [];
  allMouzaList: any[] = [];
  originalMouzaList: any[] = [];
  fileToUpload: File;
  documentList: any[] = [];
  isSubmited: boolean = false;

  fileError: boolean = false;

  preferredCountries: CountryISO[] = [
    CountryISO.Pakistan,
    CountryISO.UnitedArabEmirates,
  ];
  CountryISO = CountryISO;
  SearchCountryField = SearchCountryField;
  separateDialCode = true;
  PhoneNumberFormat = PhoneNumberFormat;

  editor: Editor;
  toolbar: Toolbar = [
    ["bold", "italic"],
    ["underline", "strike"],
    ["code", "blockquote"],
    ["ordered_list", "bullet_list"],
    [{ heading: ["h1", "h2", "h3", "h4", "h5", "h6"] }],
    ["text_color", "background_color"],
    ["align_left", "align_center", "align_right", "align_justify"],
  ];

  constructor(
    private route: Router,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private crudService: GenericCrudService,
    private appDataService: ApplicationDataService,
    private authService: AuthenticationService,
    private tokenStorage: TokenStorageService,
    private datePipe: DatePipe
  ) {
    this.divisionIds = this.tokenStorage.getDivisions();
    this.districtIds = this.tokenStorage.getDistricts();
    this.tehsilIds = this.tokenStorage.getTehsil();
    this.mouzaIds = this.tokenStorage.getMouza();
    this.workFlowStepsds = this.tokenStorage.getWorkItemSteps();
  }
  ngOnInit() {
    this.editor = new Editor({
      content: '',
      plugins: [
        new Plugin({
          key: new PluginKey('blockImagesAndSanitizePaste'),
          props: {
            handlePaste(view, event) {
              if (event.clipboardData) {
                const types = event.clipboardData.types;

                // Prevent image paste
                if (types.includes('Files')) {
                  return true;
                }

                // GET PLAIN TEXT ONLY - Ye formatting ko remove karega
                const plainText = event.clipboardData.getData('text/plain');

                if (plainText) {
                  event.preventDefault();

                  // Insert plain text without any formatting
                  const { state, dispatch } = view;
                  const { tr, selection } = state;

                  // Insert text at current cursor position
                  const transaction = tr.insertText(plainText, selection.from, selection.to);
                  dispatch(transaction);

                  return true; // Prevent default paste behavior
                }
              }
              return false;
            },

            handleDrop(view, event) {
              if (event.dataTransfer) {
                // Prevent image drop
                if (event.dataTransfer.files.length > 0) {
                  return true;
                }

                // OPTIONAL: Handle text drop bhi plain text ki tarah
                const plainText = event.dataTransfer.getData('text/plain');
                if (plainText) {
                  event.preventDefault();

                  const { state, dispatch } = view;
                  const pos = view.posAtCoords({
                    left: event.clientX,
                    top: event.clientY
                  });

                  if (pos) {
                    const transaction = state.tr.insertText(plainText, pos.pos);
                    dispatch(transaction);
                  }

                  return true;
                }
              }
              return false;
            },
          }
        })
      ]
    });
    this.form = this.formBuilder.group({
      //complaintId
      complainantTitle: [""],
      complainantName: ["", [Validators.required, Validators.maxLength(30)]],
      gender: ["", [Validators.required, Validators.maxLength(100)]],
      cnic: [
        "",
        [
          Validators.required,
          Validators.pattern(/^\d{5}-\d{7}-\d{1}$/),
          Validators.maxLength(15),
          Validators.minLength(15),
        ],
      ],
      cellPhoneNo: ["", [Validators.required, Validators.maxLength(15)]],
      email: [
        "",
        [
          // Validators.required,
          Validators.maxLength(60),
          Validators.email,
          Validators.pattern(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ),
        ],
      ],
      passportNo: ["", [Validators.maxLength(9), Validators.minLength(7)]],
      landLinePhoneNo: ["", []],
      address: ["", [Validators.maxLength(200)]],
      //ComplainDetail
      complaintId: [null],
      priority: ["LOW", [Validators.required]],
      severity: ["EASY", [Validators.required]],
      additionalCenter: ["", []],
      daysRequired: [{ value: "", disabled: true }],
      legalFramework: [{ value: "", disabled: true }],
      status: ["", []],
      assignTo: ["", []],
      //AdditionalDetail
      workCode: ["", [Validators.required]],
      complaintSource: [""],
      tier: ["", []],
      helplineIdentifier: [""],
      expectedResolutionDate: [{ value: "", disabled: true }],
      actualResolutionDate: [""],
      complaintResolutionDetail: [""],
      divisionId: ["", [Validators.required]],
      districtId: ["", [Validators.required]],
      tehsilId: ["", [Validators.required]],
      mouzaId: ["", [//Validators.required
      ]],
      complaintCategoryId: ["", [Validators.required]],
      complaintSubcategoryId: ["", [Validators.required]],
      complaintDocumentIds: [null],
      complaintDetails: [
        "",
        [
          Validators.required,
          this.descriptionMaxLength(1500),
          this.invalidDescription,
        ],
      ],
      //Not Used
      callType: [""],
      callStatus: [""],
      boothCliNumber: [""],
      segmentId: ["", [Validators.required]],
      complaintAddress: ["", [Validators.required, Validators.maxLength(200)]],
      isAnonymous: [false],
      otherForum: ["", [Validators.maxLength(200)]],
      otherSource: [""],
    });
    this.getComplaintCategoryBySegment(this.authService.getUserSegment());
    this.getDivisions();
    this.getDistrict();
    this.getTehsil();
    this.getMouza();

    this.appDataService.getAllInternalUsers().subscribe({
      next: (res: any) => {
        this.usersList = res?.data;
      },
    });
    // this.form.setValue();
    this.f["complaintCategoryId"].valueChanges.subscribe((value) => {
      if (value) {
        this.getAllComplaintByParentCategory(value);
      }
      // Clear fields on category change
      this.f["expectedResolutionDate"].reset();
      this.f["daysRequired"].reset();
      this.f["legalFramework"].reset();
    });

    // Handle Complaint Subcategory changes
    this.f["complaintSubcategoryId"].valueChanges.subscribe((value) => {
      if (value) {
        let exist = this.subCategoryList.find(
          (d) => d.complaintCategoryId == value
        );
        this.f["daysRequired"].setValue(exist?.complaintResolutionPeriod);
        this.f["legalFramework"].setValue(exist?.legalFramework);

        // Calculate the expected resolution date
        const date = new Date();
        let daysAdded = 0;

        const isWeekend = (date: Date): boolean => {
          const day = date.getDay();
          return day === 0 || day === 6;
        };

        while (daysAdded < exist?.complaintResolutionPeriod) {
          date.setDate(date.getDate() + 1);
          if (!isWeekend(date)) {
            daysAdded++;
          }
        }

        const newDate = this.datePipe.transform(date, "dd-MM-yyyy");
        this.f["expectedResolutionDate"]?.setValue(newDate);
      }
    });

    this.f["divisionId"].valueChanges.subscribe((value) => {
      // Reset the lists and form controls
      this.districtList = [];
      this.tehsilList = [];
      this.mouzaList = [];
      this.f["districtId"].setValue("");
      this.f["tehsilId"].setValue("");
      this.f["mouzaId"].setValue("");

      if (value) {
        // Filter districts based on the selected division
        this.districtList = this.allDistrictList.filter(
          (d) => d.parentAdminStrId == value
        );
        // Assign original district list
        this.originalDistrictList = [...this.districtList];
      }
    });
    this.f["districtId"].valueChanges.subscribe((value) => {
      if (value) {
        this.tehsilList = this.allTehsilList.filter(
          (d) => d.parentAdminStrId == value
        );
        this.originalTehsilList = [...this.tehsilList];
        this.mouzaList = [];
        this.f["mouzaId"].setValue("");
      }
    });
    this.f["tehsilId"].valueChanges.subscribe((value) => {
      if (value) {
        this.mouzaList = this.allMouzaList.filter(
          (d) => d.parentAdminStrId == value
        );
        this.originalMouzaList = [...this.mouzaList];
      }
    });
  }

  formatCnic(event: any) {
    const cnicValue: string = event.target.value;
    const formattedCnic: string = cnicValue
      .replace(/[^0-9]/g, "")
      .replace(/(\d{5})(\d{7})(\d{1})/, "$1-$2-$3");
    this.form.patchValue({ cnic: formattedCnic });

    // Clear previous validation errors if CNIC format is correct
    if (
      this.form.controls["cnic"].errors &&
      this.form.controls["cnic"].errors["pattern"] &&
      formattedCnic.match(/^\d{5}-\d{7}-\d{1}$/) !== null
    ) {
      this.form.controls["cnic"].setErrors(null);
    } else if (formattedCnic && !formattedCnic.match(/^\d{5}-\d{7}-\d{1}$/)) {
      this.form.controls["cnic"].setErrors({ pattern: true });
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  get descriptionLength(): number {
    const html: string = this.f['complaintDetails'].value || '';
    return html.replace(/<[^>]*>/g, '').length;
  }
  getComplaintCategoryBySegment(id: number) {
    this.appDataService.getAllComplaintCategoriesBySegment(id).subscribe({
      next: (res: any) => {
        this.categoryList = res?.data;
        this.originalCategoryList = [...this.categoryList];
      },
    });
  }
  getAllComplaintByParentCategory(id: number) {
    this.appDataService.getAllComplaintByParentCategory(id).subscribe({
      next: (res: any) => {
        this.subCategoryList = res?.data;
        this.originalSubbCategoryList = [...this.subCategoryList];
      },
    });
  }

  filterComplaintCategory(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.categoryList = this.categoryList.filter((division) =>
        division.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.categoryList = this.originalCategoryList; // Reset to original data
    }
  }

  filterSubCategory(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.subCategoryList = this.subCategoryList.filter((division) =>
        division.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.subCategoryList = this.originalSubbCategoryList; // Reset to original data
    }
  }

  getDivisions() {
    this.appDataService.getAdminStructureByIds(this.divisionIds).subscribe({
      next: (res: any) => {
        this.allDivisionList = res?.data;
        this.originalDivisionList = [...this.allDivisionList];
      },
    });
  }

  getDistrict() {
    this.appDataService.getAdminStructureByIds(this.districtIds).subscribe({
      next: (res: any) => {
        this.allDistrictList = res?.data;
      },
    });
  }
  getTehsil() {
    this.appDataService.getAdminStructureByIds(this.tehsilIds).subscribe({
      next: (res: any) => {
        this.allTehsilList = res?.data;
      },
    });
  }
  getMouza() {
    this.appDataService.getAdminStructureByIds(this.mouzaIds).subscribe({
      next: (res: any) => {
        this.allMouzaList = res?.data;
      },
    });
  }
  filterDivisions(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.allDivisionList = this.allDivisionList.filter((division) =>
        division.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.allDivisionList = this.originalDivisionList; // Reset to original data
    }
  }

  filterDistricts(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.districtList = this.districtList.filter((division) =>
        division.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.districtList = this.originalDistrictList; // Reset to original data
    }
  }

  filterTehsil(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.tehsilList = this.tehsilList.filter((division) =>
        division.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.tehsilList = this.originalTehsilList; // Reset to original data
    }
  }

  filterMouza(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.mouzaList = this.mouzaList.filter((division) =>
        division.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.mouzaList = this.originalMouzaList; // Reset to original data
    }
  }

  clearSearch(selectedOption: string) {
    switch (selectedOption) {
      case "category":
        this.searchComplaint.nativeElement.value = "";
        this.categoryList = this.originalCategoryList;
        break;
      case "subCategory":
        this.searchSubCat.nativeElement.value = "";
        this.subCategoryList = this.originalSubbCategoryList;
        break;
      case "division":
        this.searchDivision.nativeElement.value = "";
        this.allDivisionList = this.originalDivisionList;
        break;
      case "district":
        this.searchDistrict.nativeElement.value = "";
        this.districtList = this.originalDistrictList;
        break;
      case "tehsil":
        this.searchTehsil.nativeElement.value = "";
        this.tehsilList = this.originalTehsilList;
        break;
      case "mouza":
        this.searchMouza.nativeElement.value = "";
        this.mouzaList = this.originalMouzaList;
        break;
    }
  }
  add() {
    const data = this.form.getRawValue();
    //delete data.daysRequired;
    //delete data.legalFramework;
    data.cellPhoneNo = data.cellPhoneNo.e164Number;

    if (data.expectedResolutionDate) {
      // Input date string
      let dateString = data.expectedResolutionDate;

      // Split the date string into components
      let dateParts = dateString.split("-");

      // Rearrange and join the components in 'YYYY-MM-DD' format
      let formattedDateString = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;

      // Create a new Date object and convert to ISO string
      data.expectedResolutionDate = new Date(formattedDateString).toISOString();
    }

    this.crudService
      .add(data, AppUrlConstants.COMPLAINT_URL + AppUrlConstants.ADD)
      .subscribe({
        next: (res: any) => {
          this.openAlert(
            `Complaint saved Successfully!\nYour complaint no. is ${res.data.complaintNo}`
          );
          this.route.navigate(["complaint"]);
        },
        error: (e) => {
          if (e?.status == 409) {
            if (e?.error?.errors !== null) {
              for (const property in e.error.errors) {
                this.openAlert(e.error.errors[property]);
              }
            } else {
              this.openAlert(e?.error?.message);
            }
          }
        },
      });
  }

  edit() {
    this.crudService
      .edit(
        this.form.value,
        AppUrlConstants.COMPLAINT_URL + AppUrlConstants.EDIT
      )
      .subscribe({
        next: (res: any) => {
          this.openAlert("Complaint updated Successfully!");
          this.route.navigate(["complaint"]);
        },
        error: (e) => {
          if (e?.status == 409) {
            if (e?.error?.errors !== null) {
              for (const property in e.error.errors) {
                this.openAlert(e.error.errors[property]);
              }
            } else {
              this.openAlert(e?.error?.message);
            }
          }
        },
      });
  }

  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: "OK",
        },
      },
    });
  }

  private getDocumentIds(list: any) {
    let ids: any = [];
    list?.forEach((i: any) => {
      ids.push(i?.complaintDocumentId);
    });
    return ids;
  }

  onSelectFile(event: any) {
    this.fileToUpload = event.target.files.item(0);
    if (this.fileToUpload) {
      //     // Check file type and size
      const allowedTypes = [
        "image/png",
        "image/jpg",
        "image/jpeg",
        "image/gif",
        "application/pdf",
      ];
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      // if (this.fileToUpload.type !== "" && (this.fileToUpload.type === "image/png" || this.fileToUpload.type === "image/jpg" || this.fileToUpload.type === "image/jpeg" || this.fileToUpload.type === "image/gif" || this.fileToUpload.type === "application/pdf") && this.fileToUpload.size < 5000000) {
      if (
        allowedTypes.includes(this.fileToUpload.type) &&
        this.fileToUpload.size <= maxSize
      ) {
        this.fileError = false;
        const formdata: FormData = new FormData();
        formdata.append("isPublished", "true"); // Append isPublished key
        formdata.append("file", this.fileToUpload);
        this.appDataService.addDocumentService(formdata).subscribe({
          next: (res: any) => {
            this.documentList.push(res?.data);
            this.f["complaintDocumentIds"].setValue(
              this.getDocumentIds(this.documentList)
            );
          },
        });
      } else {
        // Clear the file input and show error message
        // event.target.value = null;
        this.fileError = true;
      }
      event.target.value = null;
    }
  }

  cancel() {
    this.route.navigate(["complaint"]);
  }
  truncateText(text: string, charLimit: number): string {
    if (!text) return ""; // Handle null or undefined values gracefully
    return text.length > charLimit
      ? text.substring(0, charLimit) + "..."
      : text;
  }
  // Helper method to get dynamic CSS class
  getPhoneInputClass(): string {
    return this.f["isAnonymous"]?.value
      ? 'custom-control custom-phone-input w-100 phone-input-anonymous'
      : 'custom-control custom-phone-input w-100 phone-input-bold';
  }
  onPhoneNumberChange(event: Event) {
    const input = (event.target as HTMLInputElement).value;
    if (isNaN(Number(input))) {
      this.f["cellPhoneNo"].setValue(null);
    }
  }
  download(id: number) {
    this.crudService
      .getById(
        id,
        AppUrlConstants.COMPLAINT_URL + AppUrlConstants.DOCUMENT_DOWNLOAD
      )
      .subscribe({
        next: (res: any) => {
          var link = document.createElement("a");
          link.href =
            "data:" +
            res?.data?.documentType +
            ";base64," +
            res?.data?.complaintDocument;
          link.download = res?.data?.documentName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        error: (e) => {
          if (e?.status == 409) {
            if (e?.error?.errors !== null) {
              for (const property in e.error.errors) {
                this.openAlert(e.error.errors[property]);
              }
            } else {
              this.openAlert(e?.error?.message);
            }
          }
        },
      });
  }

  removeDocument(index: number) {
    this.documentList.splice(index, 1);
    this.f["complaintDocumentIds"].setValue(
      this.getDocumentIds(this.documentList)
    );
  }

  sanitizeInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const sanitizedValue = inputElement.value.replace(/[^0-9]/g, "");

    if (sanitizedValue !== inputElement.value) {
      // Move the cursor to the end of the input after sanitizing
      const start = inputElement.selectionStart;
      const end = inputElement.selectionEnd;
      this.form.controls["cellPhoneNo"].setValue(sanitizedValue, {
        emitEvent: false,
      });

      setTimeout(() => {
        inputElement.setSelectionRange(start, end);
      }, 0);
    }
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  invalidDescription(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === "<p></p>" || !value.trim()) {
      return { invalidDescription: true };
    }
    return null;
  }

  descriptionMaxLength(max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const plain = (control.value || '').replace(/<[^>]*>/g, '');
      return plain.length > max ? { maxlength: { requiredLength: max, actualLength: plain.length } } : null;
    };
  }

  onSourceChange() {
    if (this.f["otherSource"].value === "Other") {
      this.f["otherSource"].setValidators([
        Validators.required,
        Validators.maxLength(30),
      ]);
    } else {
      this.f["otherSource"].removeValidators([
        Validators.required,
        Validators.maxLength(30),
      ]);
    }
  }
}
